// extracted by mini-css-extract-plugin
export var infoSection = "_c-1";
export var infoSectionContainer = "_c-0";
export var infoSectionTitleRow = "_c-2";
export var multiLineInfo = "_c-4";
export var strong = "_c-3";